import { render, staticRenderFns } from "./AddFundHistory1.vue?vue&type=template&id=8cc6ac38&"
import script from "./AddFundHistory1.vue?vue&type=script&lang=js&"
export * from "./AddFundHistory1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports